import * as React from "react";
import { SVGProps } from "react";
const SvgStar = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 4c2.71 0 5.423.3 8.134.8a3.84 3.84 0 0 1 3.113 3.1 43.942 43.942 0 0 1 0 16.2c-.302 1.6-1.507 2.8-3.113 3.1-2.711.5-5.423.8-8.134.8-2.711 0-5.422-.3-8.134-.8-1.607-.3-2.812-1.5-3.113-3.1-1.004-5.3-1.004-10.8 0-16.2.3-1.6 1.506-2.8 3.113-3.1 2.44-.45 4.88-.738 7.32-.791l.814-.01V4Zm.472 4.174a.5.5 0 0 0-.944 0L13.8 13.107l-5.225.118a.5.5 0 0 0-.292.898l4.157 3.167-1.502 5.005a.501.501 0 0 0 .764.555l4.013-2.778a.5.5 0 0 1 .568 0l4.013 2.778a.499.499 0 0 0 .763-.555l-1.501-5.005 4.157-3.167a.5.5 0 0 0-.292-.898l-5.225-.118-1.727-4.933h.001Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgStar;
